import React from 'react';
import PropTypes from 'prop-types';
import style from './index.css';
import { rel } from '../../utils/rel';
import errorBoundary from '@ifeng-fe/errorBoundary';

class Logo extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };
    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;
        const { logo } = content;

        return (
            <div>
                <div className={style.logo}>
                    <span />
                </div>
                <div className={style.sub_logo}>
                    <img src={logo} alt="" />
                </div>
                <div className={style.breadcrumbs}>
                    <a href="http://www.ifeng.com/" target="_blank" rel={rel} style={{ display: 'none' }}>
                        独家汇总页
                    </a>
                    {/* {' | '} */}
                    <a href="http://www.ifeng.com/" target="_blank" rel={rel}>
                        凤凰网首页
                    </a>
                </div>
            </div>
        );
    }
}
export default errorBoundary(Logo);
